import { IProviderReport } from 'src/types/providerReport';

export const groupProviderReportToCsv = (data: IProviderReport[]) => {
    const groupData: any = [
        [
            'Provider',
            'Worked, hrs',
            'Bonus, $',
            'Admin Work,$',
            'Internal,$',
            'Payroll, $',
            'Confirmed Amount, $',
            'Invoice Amount, $',
            'Invoice Paid, $',
            'Invoice Due, $',
            'Invoice Written-off, $',
            'Owed to Staff, $',
            'Fixed Salary, $',
            'Total Collected, $',
        ],
    ];
    data.forEach((it) => {
        groupData.push([
            it.fullName ? it.fullName : '',
            it.totalHoursWorked ? it.totalHoursWorked : '',
            it.totalBonus ? it.totalBonus : '',
            it.adminWorkTotal ? it.adminWorkTotal : '',
            it.internalTotal ? it.internalTotal : '',
            it.totalPayroll ? it.totalPayroll : '',
            it.totalConfirmedAmount ? it.totalConfirmedAmount : '',
            it.totalBilledAmount ? it.totalBilledAmount : '',
            it.totalBilledPaidAmount ? it.totalBilledPaidAmount : '',
            it.totalBilledDueAmount ? it.totalBilledDueAmount : '',
            it.totalWrittenOffAmount ? it.totalWrittenOffAmount : '',
            it.totalPayrollLeft ? it.totalPayrollLeft : '',
            it.salaryTotal ? it.salaryTotal : '',
            it.totalCollected ? it.totalCollected : '',
        ]);
    });

    return groupData;
};
